import React from 'react';
import {
  TooltipProvider,
  TooltipAnchor,
  Tooltip as ArikitTooltip,
} from '@ariakit/react';
import styled, { css } from 'styled-components';

const AnchorWrapper = styled(TooltipAnchor)<{ type?: any }>(
  ({ type }) => css`
    cursor: pointer;
    display: inline-block;
    ${
      type &&
      css`
        display: inherit;
      `
    }
  `,
);

const TooltipWrapper = styled(ArikitTooltip)(
  ({ theme }) => css`
    max-width: 350px;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 5px;
    font-size: 0.8rem;
    white-space: pre-line;
    background-color: ${theme.colors.greyDark};
    color: ${theme.colors.white};
  `,
);

interface TooltipProps {
  children: React.ReactNode;
  text: React.ReactNode;
  [key: string]: any;
}

function Tooltip({ children, text, ...props }: TooltipProps) {
  const isElement = React.isValidElement(children);
  return (
    <TooltipProvider placement="bottom">
      <AnchorWrapper
        type={isElement ? children.type : undefined}
        render={isElement ? children : undefined}
      >
        {isElement ? undefined : children}
      </AnchorWrapper>
      <TooltipWrapper {...props}>{text}</TooltipWrapper>
    </TooltipProvider>
  );
}

export default Tooltip;
